import { Component, OnInit } from '@angular/core';
import { MenuService } from 'src/app/menu.service';

declare var jQuery: any;
declare var sectorsInit: any;
declare var paceLoad: any;

@Component({
  selector: 'app-residential',
  templateUrl: './residential.component.html',
  styleUrls: ['./residential.component.css']
})
export class ResidentialComponent implements OnInit {

  constructor(public menuCtrl: MenuService) { }

  ngOnInit() {
    // paceLoad();
    sectorsInit();

    let el = document.getElementById("nav-toggle");
    let nav = document.getElementById("nav__content");
    let inNav = document.getElementById("sectores-items");
    let sect = document.getElementById("sector");
    let subStatus = false;
    
    sect.onclick = function() {
      subStatus = !subStatus;
      myFunction();
    };

    function myFunction() {
      if (subStatus == true ){
        inNav.style.height = "150px";
      }else{
        inNav.style.height = "0px";
      }
  }
  }
}
